module.exports = ".bolder {\n  font-weight: bolder;\n}\n\n.m {\n  margin: 1.5rem 3rem;\n  margin-top: unset;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #ccc;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/price-control/price-control.component.css
// module id = ./src/app/price-control/price-control.component.css
// module chunks = main